import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

const pageRange = (page, totalPages, padding = 2) => {
  let first,
    last,
    diff,
    pages = [];

  first = page - padding;
  first = first < 1 ? 1 : first;
  diff = padding - (page - first);
  last = page + padding + diff;
  last = last >= totalPages ? totalPages : last;

  for (let i = first; i <= last; i++) {
    pages.push(i);
  }

  return pages;
};

const firstVisible = (range) => range.slice().shift() === 1;
const lastVisible = (range, totalPages) => range.slice().pop() === totalPages;

const getLimiteInicialPagina = (page, limit, totalDocs) => {
  if (totalDocs == 0 || totalDocs == undefined) return 0;
  return page * limit - limit + 1;
};
const getLimiteFinalPagina = (page, limit, totalDocs) => {
  const limitePagina = page * limit;
  if (limitePagina > totalDocs) return totalDocs;
  return limitePagina;
};

const Pagination = ({
  t,
  page,
  totalPages,
  totalDocs,
  limit,
  customLimits,
  handleLimitChange = () => {},
  handlePageChange = () => {},
}) => {
  const range = pageRange(page, totalPages);
  const limiteInicialPagina = getLimiteInicialPagina(page, limit, totalDocs);
  const limitePagina = getLimiteFinalPagina(page, limit, totalDocs);
  const renderPages = () => {
    return range.map((i) => (
      <li
        key={i}
        className={classnames('page-item', {
          active: i === page,
        })}
      >
        <a
          onClick={(e) => {
            e.preventDefault();
            handlePageChange(i);
          }}
          className="page-link"
        >
          {i}
        </a>
      </li>
    ));
  };

  return (
    <div className="row align-items-center">
      <div className="col-sm-6">
        {totalPages > 0 && (
          <ul className="pagination">
            <li className="page-item">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(1);
                }}
                className="page-link"
              >
                {'<<'}
              </a>
            </li>
            <li className="page-item">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(page - 1 > 0 ? page - 1 : 1);
                }}
                className="page-link"
              >
                {t('pagination.prev')}
              </a>
            </li>
            {!firstVisible(range) && (
              <li className="page-item">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="page-link disabled"
                >
                  ...
                </a>
              </li>
            )}
            {renderPages()}
            {!lastVisible(range, totalPages) && (
              <li className="page-item">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="page-link disabled"
                >
                  ...
                </a>
              </li>
            )}
            <li className="page-item">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(page + 1 <= totalPages ? page + 1 : totalPages);
                }}
                className="page-link"
              >
                {t('pagination.next')}
              </a>
            </li>
            <li className="page-item">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(totalPages);
                }}
                className="page-link"
              >
                {'>>'}
              </a>
            </li>
          </ul>
        )}
      </div>
      <div className="col-sm-6">
        <div className="form-inline pull-right">
          <label className="mr-2">{t('pagination.show')}</label>
          {customLimits ? (
            <select
              className="form-control"
              value={limit}
              onChange={(e) => {
                e.preventDefault();
                handleLimitChange(e.target.value);
              }}
            >
              {customLimits.map((limit) => (
                <option value={limit}>{limit}</option>
              ))}
            </select>
          ) : (
            <select
              className="form-control"
              value={limit}
              onChange={(e) => {
                e.preventDefault();
                handleLimitChange(e.target.value);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          )}
          <label className="ml-2">{t('pagination.per_page')} </label>
          <label className="ml-4">
            {limiteInicialPagina}-{limitePagina} {t('pagination.of')} {totalDocs}
          </label>
        </div>
      </div>
    </div>
  );
};

export default translate()(Pagination);



// WEBPACK FOOTER //
// src/modules/common/components/Pagination.js